import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './PatientSelector.css'
import withPolyglot from '../../../common/withPolyglot'

const NON_NUMERIC_REGEX = /^\D*$/

const RECENTS_OPTION_VALUE = 'recent'
const RECENTS_OPTION_LABEL = 'recent'
const HEALTH_ID_OPTION_VALUE = 'id'
const HEALTH_ID_OPTION_LABEL = 'id'

class SearchForm extends Component {
  static propTypes = {
    searchRecents: PropTypes.func.isRequired,
    searchID: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      input: '',
      formColor: '',
      recents: true
    }
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  handleFormSubmit (e) {
    e.preventDefault()
    e.target.reset()
  }

  searchRecents (value) {
    const numeric = !NON_NUMERIC_REGEX.exec(value)
    let formColor = numeric ? 'red' : ''
    this.setState({formColor, input: value})
    if (!numeric) {
      this.props.searchRecents(value)
    }
  }

  searchHealthID (value) {
    this.setState({input: value})
    this.props.searchID(value)
  }

  handleInputChange (e) {
    const {value} = e.target
    if (this.state.recents) {
      this.searchRecents(value)
    } else {
      this.searchHealthID(value)
    }
  }

  handleSelectChange (e) {
    const {value} = e.target
    this.setState({recents: value === RECENTS_OPTION_VALUE})
  }

  render () {
    const {input, formColor, recents} = this.state
    const { translate } = this.props
    return (
      <form
        className='patient-form uk-search uk-width-1-1'
        onSubmit={this.handleFormSubmit}
        style={{borderColor: formColor}}
      >
        <span className='search-icon' data-uk-search-icon='search; ratio: 1.7' />
        <select
          style={{borderColor: formColor, borderRight: 'none', borderLeft: 'none'}}
          className='patient-search-select uk-select uk-width-auto'
          value={recents ? RECENTS_OPTION_VALUE : HEALTH_ID_OPTION_VALUE}
          onChange={this.handleSelectChange}
        >
          <option value={RECENTS_OPTION_VALUE}>{translate(RECENTS_OPTION_LABEL)}</option>
          <option value={HEALTH_ID_OPTION_VALUE}>{translate(HEALTH_ID_OPTION_LABEL)}</option>
        </select>
        <input
          className='patient-search-input uk-search-input uk-width-1-1'
          type={recents ? 'search' : 'number'}
          placeholder={translate('searchPatient')}
          onChange={this.handleInputChange}
          value={input}
        />
      </form>
    )
  }
}

export default withPolyglot(SearchForm, 'searchForm')
